import React from "react";
import {PillButton} from "../common/PillButton";

interface OtpLoginViewProps {
    email: string;
    code: string;
    onCodeChange: (value: string) => void;
    onSubmit: () => void;
    onCancel: () => void;
}

export function OtpLoginView({email, code, onCodeChange, onSubmit, onCancel}: OtpLoginViewProps) {
    const handleCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onCodeChange(event.target.value.replace(/\D/g, "").slice(0, 6));
    };

    const activeCellIndex = Math.min(code.length, 5);

    return (
        <div className="otp-login-view">
            <div className="otp-login-view-heading">CHECK YOUR EMAIL!</div>
            <div className="otp-login-view-subheading">We sent you a sign-in code.</div>
            <div className="otp-login-view-code">
                <input
                    className="otp-login-view-code-field"
                    maxLength={6}
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    autoFocus={true}
                    value={code}
                    onChange={handleCodeChange}
                />
                <div className="otp-login-view-code-cells">
                    {[0, 1, 2, 3, 4, 5].map((index) => (
                        <div
                            key={index}
                            className={`otp-login-view-code-cell${index === activeCellIndex ? " active" : ""}`}
                        >
                            {code[index] || ""}
                        </div>
                    ))}
                </div>
            </div>
            <PillButton
                buttonClasses="solid-green-button"
                buttonText="SUBMIT"
                onClick={onSubmit}
            />
            <div className="otp-login-view-sent-to">
                <span className="otp-login-view-sent-to-prefix">Sent to:</span>
                <span className="otp-login-view-sent-to-email">{email}</span>
            </div>
            <div className="otp-login-view-inbox-hint">
                Not in your inbox? Give it a minute, then check Spam or Junk.
            </div>
            <a className="otp-login-view-cancel-link" onClick={onCancel}>CANCEL</a>
        </div>
    );
}
